import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DealsService } from '@app/deals/services/deals.service';
import { MorePage } from '@app/more/more.page';
import { MoreService } from '@app/more/services/more.service';
import { CustomerStoreService } from '@app/ngrx-customer/services';
import { UserService } from '@app/user/services';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { NotificationsService } from '@notifications/services/notifications.service';
import { AuthConnectService, PanAppState } from '@panamax/app-state';
import { HeaderService } from '@shared/components/header/header.service';
import { NavigationHelperService } from '@shared/helpers/navigation.helpers.service';
import { AppService } from '@shared/services/app.service';
import { ModalService } from '@shared/services/modal/modal.service';
import { UpcService } from '@shared/services/upc/upc.service';
import {
  DeliveryStoreService,
  IMPORT_ORDERS_ACTIONS,
  ImportOrdersStoreService,
} from '@usf/ngrx-order';
import { OrderTransaction } from '@usf/order-types';
import { BehaviorSubject, Observable } from 'rxjs';
import { PunchoutService } from '../../../punchout/services/punchout.service';
import { PATHS } from '../../../shared/constants/paths';
import { ProductAnalyticsService } from '@usf/ngrx-product';
import { InviteNewUserService } from '@shared/services/invite-new-user/invite-new-user.service';
import { TranslateService } from '@ngx-translate/core';
import { FEATURES } from '@shared/constants/splitio-features';
import { DivisionPhoneNumberService } from '@shared/services/division-phone-number/division-phone-number.service';
import { PageTitle } from '@shared/constants/page-titles.enum';
import { ToggleNewSearchService } from '@shared/services/toggle-new-search/toggle-new-search.service';
import { GuestPageService } from '@shared/services/guest-page/guest-page.service';

@Component({
  selector: 'app-my-orders-menu',
  templateUrl: './my-orders-menu.page.html',
  styleUrls: ['./my-orders-menu.page.scss'],
})
export class MyOrdersMenuPage extends MorePage {
  importOrderModalIsOpen$ = new BehaviorSubject<boolean>(false);
  importOrdersLoading$: Observable<boolean> =
    this.importOrdersStoreService.loading$();
  importOrdersLoaded$: Observable<boolean> =
    this.importOrdersStoreService.loaded$();
  importOrdersTransactions$: Observable<OrderTransaction[]> =
    this.importOrdersStoreService.orderTransactions$();
  fileImportErrors$: Observable<string[]> =
    this.importOrdersStoreService.fileImportErrors$();

  importedOrdersFeatureFlag = FEATURES.split_global_imported_orders.name;
  imageOrderingFeatureFlag = FEATURES.split_dynamic_order_image_ordering.name;

  fileImportMessage$: Observable<string> =
    this.importOrdersStoreService.message$();
  apiError$: Observable<string> = this.importOrdersStoreService.error$();

  constructor(
    router: Router,
    store: Store,
    modalController: ModalController,
    panAppState: PanAppState,
    appService: AppService,
    authConnectService: AuthConnectService,
    customerStoreService: CustomerStoreService,
    dealsService: DealsService,
    headerService: HeaderService,
    modalService: ModalService,
    moreService: MoreService,
    navigationHelper: NavigationHelperService,
    notificationsService: NotificationsService,
    punchoutService: PunchoutService,
    upcService: UpcService,
    userService: UserService,
    private importOrdersStoreService: ImportOrdersStoreService,
    deliveryStoreService: DeliveryStoreService,
    analyticsService: ProductAnalyticsService,
    inviteNewUserService: InviteNewUserService,
    translateService: TranslateService,
    divisionPhoneNumberService: DivisionPhoneNumberService,
    toggleNewSearchService: ToggleNewSearchService,
    guestPageService: GuestPageService,
  ) {
    super(
      router,
      store,
      modalController,
      panAppState,
      appService,
      authConnectService,
      customerStoreService,
      dealsService,
      headerService,
      modalService,
      moreService,
      navigationHelper,
      notificationsService,
      punchoutService,
      upcService,
      userService,
      deliveryStoreService,
      analyticsService,
      inviteNewUserService,
      translateService,
      divisionPhoneNumberService,
      toggleNewSearchService,
      guestPageService,
    );
    this.pageTitle = PageTitle.myOrdersMenu;
  }

  openImportOrderModal(isOpen: boolean) {
    if (isOpen) {
      this.initializeImportOrderState(new Event(''));
    }
    this.importOrderModalIsOpen$.next(isOpen);
  }

  importOrderHandler(event: { file: File; fileType: string }) {
    this.store.dispatch(
      IMPORT_ORDERS_ACTIONS.load({
        ordersFile: event.file,
        fileType: event.fileType,
      }),
    );
  }

  handleImportModalDismiss(event) {
    if (this.importOrderModalIsOpen$.value) {
      this.openImportOrderModal(false);
    }
  }

  handleImportSuccess(event) {
    this.handleImportModalDismiss(event);
    setTimeout(() => {
      this.navigationHelperService.routeTo(PATHS.IMPORT_ORDER);
    }, 0);
  }

  initializeImportOrderState(event) {
    this.store.dispatch(IMPORT_ORDERS_ACTIONS.initialize());
  }
}
